<div *ngIf="icon" [className]="'text-block__icon icon-' + icon"></div>
<div *ngIf="img" class="text-block__img">
  <img [src]="img" alt="">
</div>
<div class="text-block__content">
  <h3 class="text-block__title">{{ title }}</h3>
  <div class="text-block__text">{{ text }}</div>
</div>